/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateEmployment} from '../api'

export const useMutationUpdateEmployment = createReactQueryMutationHook('updateEmployment', updateEmployment)
